<template>
  <div class="account-page register-page register-detail-page">
    <!-- bg -->
    <div class="bg" ref="videoBg">
      <img :src="poster" alt="" />
      <div class="mask"></div>
    </div>
    <!-- header -->
    <div class="header">
      <el-button
        type="primary"
        size="small"
        @click="goIndex"
        v-text="'< 返回首页'"
      ></el-button>
    </div>
    <!-- form wrapper -->
    <div class="form-wrapper">
      <h1 class="form-header">
        <p class="main-title">{{ pageTitle }}</p>
        <!--<p class="main-title">注册 ·  企业</p>-->
        <div class="operate">
          <el-button type="text" @click="goLogin">前往登录</el-button>
          <el-button type="text" @click="goback">重选类型</el-button>
        </div>
      </h1>
      <!-- form -->
      <el-form
        ref="form"
        class="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="email" prop="email" :error="errors.email">
              <el-input
                v-model="form.email"
                suffix-icon="el-icon-message"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="用户姓名"
              prop="authPersonName"
              :error="errors.authPersonName"
            >
              <el-input
                v-model="form.authPersonName"
                suffix-icon="el-icon-user"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="用户手机号"
              prop="authPersonMobile"
              :error="errors.authPersonMobile"
            >
              <el-input
                v-model="form.authPersonMobile"
                suffix-icon="el-icon-phone-outline"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="pwd" :error="errors.pwd">
              <el-input
                v-model="form.pwd"
                clearable
                show-password
                placeholder="6至15个字符"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="确认密码"
              prop="pwdCopy"
              :error="errors.pwdCopy"
            >
              <el-input
                v-model="form.pwdCopy"
                clearable
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 阅读协议 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="" class="no-border no-margin">
              <el-checkbox-group v-model="form.isAgree" class="protocol-form">
                <el-checkbox label="我已阅读并同意"></el-checkbox>
                <el-button class="protocol" type="text" @click="showProtocol">{{
                  protocolName
                }}</el-button>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 提交 -->
        <el-row :gutter="20">
          <el-form-item class="no-border">
            <!-- 远端错误 -->
            <el-alert
              class="error"
              v-if="error"
              type="error"
              :closable="false"
              >{{ error }}</el-alert
            >
            <el-button
              type="primary"
              class="submit-button"
              @click="submit"
              :loading="loading"
              >注册</el-button
            >
          </el-form-item>
        </el-row>
      </el-form>

      <!-- 协议 -->
      <protocol
        ref="protocol"
        @on-update="updateProtocol"
        @on-agree="agreeProtocol"
      ></protocol>
    </div>
  </div>
</template>

<script>
import mixin from "./mixins/mixin";

export default {
  mixins: [mixin],
  data() {
    return {
      form: {
        registerMode: "6", // 个人模式
        authPersonName: "",
        authPersonMobile: "",
        email: "",
        pwd: "",
        pwdCopy: "",
        // 冗余字段
        isAgree: []
      },
      rules: {
        email: [
          { required: true, message: "请输入邮箱" },
          {
            type: "string",
            pattern: /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/,
            message: "请输入正确的邮箱地址",
            trigger: "change"
          }
        ],
        authPersonName: [
          { required: true, message: "请输入姓名", trigger: "change" }
        ],
        authPersonMobile: [
          { required: true, message: "请输入手机号", trigger: "change" }
        ],
        pwd: [
          { required: true, message: "请输入密码", trigger: "change" },
          {
            type: "string",
            min: 6,
            max: 15,
            message: "请设置6至15个字符的密码",
            trigger: "change"
          }
        ],
        pwdCopy: [
          { required: true, message: "请再次输入密码", trigger: "change" },
          {
            type: "string",
            min: 6,
            max: 15,
            message: "请设置6至15个字符的密码",
            trigger: "change"
          },
          {
            validator: this.validSamePassword,
            message: "请保持密码一致",
            trigger: "change"
          }
        ]
      },
      errors: {
        authPersonName: "",
        authPersonMobile: "",
        email: "",
        pwd: "",
        pwdCopy: ""
      },
      loading: false
    };
  },
  computed: {
    poster() {
      return `${this.baseUrl}media/trade_cover.png`;
    }
  },
  created() {
    this.test();
  },
  methods: {
    test() {
      // this.form.email = "30254779@qq.com";
      this.form.email = "1@qq.com";
      // this.form.authPersonName = "王堃宇";
      this.form.authPersonName = "张茜茜";
      // this.form.authPersonMobile = "17783174069";
      this.form.authPersonMobile = "15223284591";
      this.form.pwd = "123456";
      this.form.pwdCopy = "123456";
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/pages/account.scss";
</style>
